import { PublicImage } from '~/service/__generated-api'

export type AspectRatioParams =
  | { w: number; aspectRatio: number }
  | { h: number; aspectRatio: number }

export function sizeWithAspectRatio(params: AspectRatioParams): {
  w: number
  h: number
} {
  if ('w' in params)
    return { w: params.w, h: (1 / params.aspectRatio) * params.w }

  return { h: params.h, w: params.aspectRatio * params.h }
}

export function getAspectRatio(image: PublicImage, defaultAspectRatio = 1) {
  return image.width && image.height
    ? image.width / image.height
    : defaultAspectRatio
}
